module.exports = __webpack_public_path__ + "static/riptidemg-7bb93b11129944f2a0d8d8c72d8facc1.png";